import copy from 'fast-copy';
import { OpPatch } from 'json-patch';
import axios, { AxiosRequestHeaders } from 'axios';
import endpoints from './adapters/endpoints';
import createHttpClient from './createHttpRequest';
import {
  Adapter,
  AxiosInstance,
  MakeRequestOptions,
  MakeRequestPayload,
  RestAdapterParams,
} from './commonTypes';

/**
 * @private
 */
const defaultHostParameters = {
  defaultHostname: 'api.digicommercegroup.com',
  defaultHostnameUpload: 'upload.digicommercegroup.com',
};

export class RestAdapter implements Adapter {
  private readonly params: RestAdapterParams;

  public constructor(params: RestAdapterParams) {
    // if (!params.accessToken) {
    //   throw new TypeError('Expected parameter accessToken');
    // }

    this.params = {
      ...defaultHostParameters,
      ...copy(params),
    };
  }

  public async makeRequest<R>({
    entityType,
    action: actionInput,
    params,
    payload,
    headers,
    userAgent,
  }: MakeRequestOptions): Promise<R> {
    // `delete` is a reserved keyword. Therefore, the methods are called `del`.
    const action = actionInput === 'delete' ? 'del' : actionInput;

    const endpoint: (
      http: AxiosInstance,
      params?: Record<string, unknown>,
      payload?: Record<string, unknown> | OpPatch[] | MakeRequestPayload,
      headers?: AxiosRequestHeaders
    ) => Promise<R> =
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      endpoints[entityType]?.[action];

    if (endpoint === undefined) {
      throw new Error('Unknown endpoint');
    }

    const requiredHeaders = {
      'Content-Type': 'application/vnd.digicommerce.management.v1+json',
      'X-Digi-User-Agent': userAgent || '',
    };

    // TODO: maybe we can avoid creating a new axios instance for each request
    const axiosInstance = createHttpClient(axios, {
      ...this.params,
      headers: {
        ...requiredHeaders,
        ...this.params.headers,
      },
    });
    return await endpoint(axiosInstance, params, payload, headers);
  }
}
